/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessReportFilterFromJSON, BusinessReportFilterToJSON, } from './BusinessReportFilter';
/**
 * Check if a given object implements the BusinessReportListRequest interface.
 */
export function instanceOfBusinessReportListRequest(value) {
    if (!('filter' in value) || value['filter'] === undefined)
        return false;
    return true;
}
export function BusinessReportListRequestFromJSON(json) {
    return BusinessReportListRequestFromJSONTyped(json, false);
}
export function BusinessReportListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'filter': BusinessReportFilterFromJSON(json['filter']),
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}
export function BusinessReportListRequestToJSON(json) {
    return BusinessReportListRequestToJSONTyped(json, false);
}
export function BusinessReportListRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'filter': BusinessReportFilterToJSON(value['filter']),
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}
